import React, { memo } from 'react'
import CircularProgress from '@alobato/circular-progress'
import { Formik } from 'formik'
import '../../validators'

import FormModal from '../../components/FormModal'
import Form from './Form'
import useCatalogos from '../../hooks/useCatalogos'
import { enviarCadastro } from '../../lib/enviarCadastro'
import { schemaDeCriacao } from './validationSchema'

import BASE_API from '../../constants/baseApi'

/* O cadastro já aceita o perfil inteiro: quem tem a ficha do médico em mãos na
   hora de criar não precisa salvar e reabrir para preencher o resto — e é
   assim que registro fica sem CRM e sem especialidade. */
const New = ({ onRequestClose, onCreated, especialidades, planos, clinicas }) => {
  const initialValues = {
    name: '', login: '', password: '',
    phone: '', birth_date: '', gender: '', price: '', description: '',
    crm: '', crm_uf: '', crm_secondary: '', crm_secondary_uf: '',
    specialty_primary: '', specialty_secondary: '',
    health_insurances: [], establishments: []
  }

  const handleSubmit = async (values, actions) => {
    const salvou = await enviarCadastro({
      url: `${BASE_API}/doctor/`, method: 'POST', values, actions
    })
    if (!salvou) return
    onCreated()
    onRequestClose()
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={schemaDeCriacao}
      validateOnChange={false}
      render={props => (
        <FormModal title='Novo Médico' onRequestClose={onRequestClose}
          onSubmit={props.handleSubmit} submitting={props.isSubmitting} error={props.status}>
          <Form {...props} isCreating especialidades={especialidades}
            planos={planos} clinicas={clinicas} />
        </FormModal>
      )}
    />
  )
}

export default memo(props => {
  const catalogos = useCatalogos({ clinicas: true })
  if (catalogos.carregando) return <CircularProgress color='hsla(199, 75%, 43%, 1)' />
  return (
    <New
      {...props}
      especialidades={catalogos.especialidades}
      planos={catalogos.planos}
      clinicas={catalogos.clinicas}
    />
  )
})
